import { DateTime } from 'luxon';
import { dateClient } from './date-client';
export function transformDateToDayJs(date, timezone) {
    const unprocessedDate = new Date(date);
    return dateClient()
        .tz(timezone)
        .year(unprocessedDate.getFullYear())
        .month(unprocessedDate.getMonth())
        .date(unprocessedDate.getDate())
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
}
export function transformDayJstoDate(date) {
    return new Date(date.year(), date.month(), date.date(), date.hour(), date.minute(), date.second());
}
export function convertUTCToLocalDate(utcString, targetZone) {
    const local = DateTime.fromISO(utcString, { zone: 'utc' }).setZone(targetZone);
    return new Date(local.year, local.month - 1, local.day, local.hour, local.minute, local.second, local.millisecond);
}
export function convertLocalDateToUTC(localDate, localZone) {
    const date = DateTime.fromObject({
        year: localDate.getFullYear(),
        month: localDate.getMonth() + 1,
        day: localDate.getDate(),
        hour: localDate.getHours(),
        minute: localDate.getMinutes(),
        second: localDate.getSeconds(),
        millisecond: localDate.getMilliseconds()
    }, { zone: localZone });
    return date.toUTC().toISO();
}
/**
 * Formats a conversation date string using a tiered approach:
 * - Same day: relative time ("2 hours ago", "5 minutes ago")
 * - Same week but > 2 days ago: day name ("Monday", "Tuesday")
 * - Older than a week: absolute date ("Jan 15", "Feb 19")
 */
export function formatConversationDate(dateString) {
    const date = DateTime.fromISO(dateString);
    const now = DateTime.now();
    if (!date.isValid) {
        return '';
    }
    const diffMs = now.diff(date, 'milliseconds').milliseconds;
    const diffMinutes = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    // Same day: relative time
    if (date.hasSame(now, 'day')) {
        if (diffMinutes < 1) {
            return 'Just now';
        }
        if (diffMinutes < 60) {
            return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`;
        }
        return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
    }
    // Yesterday
    if (diffDays <= 1 && date.hasSame(now.minus({ days: 1 }), 'day')) {
        return 'Yesterday';
    }
    // Same week (up to 6 days ago): day name
    if (diffDays <= 6) {
        return date.toFormat('EEEE');
    }
    // Older: absolute date
    if (date.year === now.year) {
        return date.toFormat('MMM d');
    }
    return date.toFormat('MMM d, yyyy');
}
